export const PRODUCT_ANALYTICS_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com'
